import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import {
  getAircrafts,
  deleteAircraft,
  changeAircraftStatus,
} from "../api/aircraftApi";
import { confirmDialog } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";

export default function AircraftsList() {
  const [aircrafts, setAircrafts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const loadAircrafts = async () => {
    setLoading(true);
    try {
      const res = await getAircrafts({ page, per_page: perPage });
      setAircrafts(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAircrafts();
  }, [page, perPage]);

  const handleDelete = async (id) => {
    const confirmed = await confirmDialog({ text: "Delete this aircraft?" });
    if (!confirmed) return;
    await deleteAircraft(id);
    loadAircrafts();
  };

  const handleToggleActive = async (aircraft) => {
    await changeAircraftStatus(aircraft.id, !aircraft.is_active);
    loadAircrafts();
  };

  return (
    <AdminLayout title="Aircrafts">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title mb-0">Aircraft List</h5>
            <button
              className="btn skedq-accent-btn"
              onClick={() => navigate("/aircrafts/new")}
            >
              Add New Aircraft
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Model</th>
                  <th>Manufacturer</th>
                  <th>Type</th>
                  <th>Capacity</th>
                  <th>Range</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="8" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && aircrafts.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      No aircrafts found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  aircrafts.map((a, index) => (
                    <tr key={a.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{a.model || "-"}</td>
                      <td>{a.manufacturer}</td>
                      <td>{a.aircraft_type}</td>
                      <td>{a.capacity}</td>
                      <td>{a.range_km}</td>
                      <td>
                        <span
                          className={
                            "badge " +
                            (a.is_active ? "bg-success" : "bg-secondary")
                          }
                        >
                          {a.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => navigate(`/aircrafts/edit/${a.id}`)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleToggleActive(a)}
                          >
                            {a.is_active ? "Deactivate" : "Activate"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(a.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
